<template>
    <v-row>
        <v-col cols="12" class="title-section pb-0">
            {{ $tc('coach.coach', 1) }}
        </v-col>
        <v-col cols="12" v-if="coach">
            <div class="card-container">
                <v-row align="center">
                    <v-col cols="9" lg="11" @click="goToCoach" v-ripple>
                        <div class="coach-name text-truncate">
                            {{ coach.coachName }}
                        </div>
                        <div class="coach-description text-truncate">
                            {{ coach.coachDescription }}
                        </div>
                    </v-col>
                    <v-col cols="3" lg="1" align="center" @click="showChat" v-ripple>
                        <v-badge :color="noRead ? 'black' : ''" :content="noRead ? '!' : ''" overlap :bordered="noRead">
                            <v-btn color="primary" class="border-button" depressed fab small>
                                <v-icon small class="border-icon">mdi-message-processing</v-icon>
                            </v-btn>
                        </v-badge>
                    </v-col>
                </v-row>
            </div>
            <chat-dialog :clientId="coachId" ref="chat"/>
        </v-col>
        <v-col cols="12" v-else>
            <v-alert
                color="accent"
                icon="mdi-alert-decagram-outline"
                dense outlined border="left"
                @click="goToCoaches"
                v-ripple class="pointer"
            >
                <span class="mr-3">
                    {{ $t('coach.no_hired_coach') }}
                </span>
                <v-chip color="accent" label small>
                    {{ $t('coach.see_coaches') }}
                </v-chip>
            </v-alert>
        </v-col>
    </v-row>
</template>

<script>
import {db} from "@/utils/Firebase";
import ChatDialog from "@/components/student/ChatDialog";

export default {
    name: "CurrentCoach",
    components: {ChatDialog},
    data() {
        return {
            noRead: false,
        }
    },
    async mounted() {
        const vm = this
        await vm.checkLastMessage()
    },
    computed: {
        coach(vm = this) {
            return vm.account?.studentSubscription || null
        },
        coachId(vm = this) {
            return vm.coach?.coachId || null
        },
        studentId(vm = this) {
            return vm.currentUser?.uid || null
        }
    },
    methods: {
        showChat() {
            const vm = this
            vm.$refs.chat.show()
        },
        async checkLastMessage() {
            const vm = this
            if (!vm.coach) return;
            if (!vm.coachId || !vm.studentId) return;
            let chatRef = await db.collection('privateChats')
            chatRef.where('type', '==', 'coach_student')
            chatRef.where('participants', 'in', [[vm.coachId, vm.studentId]])
                .get().then(async chat => {
                if (chat.docs.length > 0) {
                    let lastMessage = chat.docs[0].data().lastMessage || null
                    lastMessage?.from === vm.studentId ?
                        vm.noRead = false :
                        vm.noRead = lastMessage && !lastMessage.read
                }
            })
        },
        goToCoach() {
            const vm = this
            vm.$router.push({name: 'student.coach-profile', params: {uid: vm.coachId}})
        },
        goToCoaches() {
            const vm = this
            vm.$router.push({name: 'student.coaches'})
        }
    },
    watch: {
        account() {
            this.checkLastMessage()
        }
    }
}
</script>

<style scoped>

.title-section {
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
}

.card-container {
    border: thin solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    padding: 12px;
}

.coach-name {
    font-size: 20px;
    line-height: 24px;
    font-weight: bold;
}

.coach-description {
    font-size: 12px;
    color: #707070;
    line-height: 15px;
    margin-top: 4px;
}

.border-button {
    border: 2px solid var(--v-primary-darken1) !important;
}

.border-icon {
    text-shadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
}

</style>